import { createTheme } from '@material-ui/core/styles';
import { theme, cnTheme } from '../../../styles/theme';
import { getDomain } from '../../../utils/config';

const mainTheme = getDomain() === 'onsemi.com' ? theme : cnTheme;

const tableFooterTheme = createTheme({
	...mainTheme,
	overrides: {
		...mainTheme.overrides,
		MuiMenuItem: {
			...mainTheme.overrides.MuiMenuItem,
			root: {
				...mainTheme.overrides.MuiMenuItem.root,
				padding: '12px 17px 7px 12px'
			}
		}
	}
});

export default tableFooterTheme;
